import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import "./Modal.css";
import "../Document/Table.css";
import Navbar from "./Navbar";
import { FaMoneyCheckAlt,FaTimes,FaCheck } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

const AssignedRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [accountNumber, setAccountNumber] = useState("");  // For Net Banking
  const [upiId, setUpiId] = useState("");

  const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("");
  const [amount, setAmount] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [currentRequest, setCurrentRequest] = useState(null);
  const [verificationStatus, setVerificationStatus] = useState({});
  

  const handlePaymentSuccess = (requestId) => {
    setRequests((prevRequests) =>
      prevRequests.map((req) =>
        req.id === requestId ? { ...req, payment_status: "Completed" } : req
      )
    );
  };
  const clearPaymentFields = () => {
    setSelectedPaymentOption("");  // Clear selected payment option
    setAmount("");  // Clear amount
    setAccountNumber("");  // Reset account number
    setUpiId("");
  };
const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  // Pagination states
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  useEffect(() => {
    const logId = Cookies.get("log_id");

    if (!logId) {
      setError("User not logged in or session expired. Please log in again.");
      setLoading(false);
      return;
    }

    console.log("Log Id :", logId);

    axios
      .get(`${url.path}/telecaller-dashboard/`, {
        params: { log_id: logId },
        // withCredentials: true,
        headers: {
          "X-CSRFToken": Cookies.get("csrftoken"),
        },
      })
      .then((response) => {
        console.log("API Response:", response.data);
        if (response.data.status === false) {
          setError(response.data.message);
        } else {
          setRequests(response.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setError("Failed to fetch requests. Please try again later.");
        setLoading(false);
      });
  }, []);

  const handleVerifyPayment = () => {
    if (!selectedPaymentOption || !amount) {
      Toast.fire({
        icon: "warning",
        title: "Please select a payment option and enter the amount.",
      });
      // Exit if the payment option or amount is missing
      return;
    }
   
  
    if (selectedPaymentOption === "NetBanking" && !accountNumber) {
      Toast.fire({
        icon: "warning",
        title: "Please enter an account number for Net Banking.",
      });
      return;
    }
  
    if (selectedPaymentOption === "UPI" && !upiId) {
      Toast.fire({
        icon: "warning",
        title: "Please enter a UPI ID for UPI payment.",
      });
      return;
    }
  
    // Update the payment status to "Completed"
    handlePaymentSuccess(currentRequest.id);
  
    // Update verification status for the current request
    setVerificationStatus((prev) => ({
      ...prev,
      [currentRequest.id]: true,
    }));
  
    // Show success toast
    Toast.fire({
      icon: "success",
      title: "Payment verified successfully!",
    });
    clearPaymentFields();
    // Close the payment modal
    setIsPaymentModalOpen(false);
  };
  

  const handleApprove = (request) => {
    if (!verificationStatus[request.id]) {
      Toast.fire({
        icon: "warning",
        title: "You must verify the payment before approving.",
      });
      // alert("You must verify the payment before approving.");
      return;
    }

    axios
      .post(`${url.path}/approve-request/`, { request_id: request.id })
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Request approved successfully!",
        });
        
        setRequests((prev) =>
          prev.map((r) =>
            r.id === request.id ? { ...r, approval_status: "Approved" } : r
          )
        );
      })
      .catch((err) => {
        console.error("Error approving request:", err);
        Toast.fire({
          icon: "error",
          title: "Failed to approve the request. Please try again.",
        });
        
      });
  };

  const handleReject = (request) => {
    if (!rejectionReason) {
      Toast.fire({
        icon: "warning",
        title: "Please provide a reason for rejection.",
      });
      // alert("Please provide a reason for rejection.");
      return;
    }

    axios
      .post(`${url.path}/reject-request/`, {
        request_id: request.id,
        reason: rejectionReason,
      })
      .then(() => {
        Toast.fire({
          icon: "success",
          title: "Request rejected successfully!",
        });
        
        setRequests((prev) =>
          prev.map((r) =>
            r.id === request.id ? { ...r, approval_status: "Rejected" } : r
          )
        );
        setIsRejectionModalOpen(false);
      })
      .catch((err) => {
        console.error("Error rejecting request:", err);
        Toast.fire({
          icon: "error",
          title: "Failed to reject the request. Please try again.",
        });
        
      });
  };

  const handleSearch = (event) => {
    const searchTerm = event.target.value.trim().toLowerCase();
    const rows = document.querySelectorAll("#documentTable tbody tr");

    rows.forEach((row) => {
      const rowText = row.textContent.toLowerCase();
      row.style.display = rowText.includes(searchTerm) ? "" : "none";
    });
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = requests.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(requests.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div style={{ color: "red" }}>{error}</div>;
  }



  return (
    <div>
      <Navbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Assigned Requests
        </h3>
      </center>
      <div className="page-wrapper">
        <div className="input-width">
        <input
          type="text"
          id="search"
          placeholder="Search in table..."
          onInput={handleSearch} // Attach the JavaScript-based search function
          className="search-input"
        />
        </div>
      
      </div>
      <div className="table-container">

        <table className="responsive-table" id="documentTable">
          <thead>
            <tr>
              <th>Employee Name</th>
              {/* <th>Contact Number</th>
              <th>Email</th>
              <th>Current Job/Stream</th> */}
              <th>Requested Change</th>
              <th>Reason</th>
              <th>Approval Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((request) => (
                <tr key={request.id}>
                  <td>{request.employee_name}</td>
                  {/* <td>{request.contact_number || "N/A"}</td>
                  <td>{request.email || "N/A"}</td>
                  <td>{request.current_job_or_stream}</td> */}
                  <td>{request.requested_change}</td>
                  <td>{request.reason}</td>
                  <td>{request.approval_status}</td>
                  <td>
  <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
    {/* Payment Button */}
    <button
      onClick={() => {
        setCurrentRequest(request);
        setIsPaymentModalOpen(true);
      }}
      disabled={
        request.payment_status === "Completed" || // Disable if payment is completed
        request.approval_status === "Approved" || // Disable if already approved
        request.approval_status === "Rejected" // Disable if already rejected
      }
      style={{
        backgroundColor:
          request.payment_status === "Completed"
            ? "#28a745" // Green to indicate payment completed
            : request.approval_status === "Approved" ||
              request.approval_status === "Rejected"
            ? "#ccc" // Grey to indicate disabled
            : "#007bff", // Blue for active payment
        color: "white",
        border: "none",
        borderRadius: "5px",
        padding: "5px 10px",
        cursor:
          request.payment_status === "Completed" ||
          request.approval_status === "Approved" ||
          request.approval_status === "Rejected"
            ? "not-allowed"
            : "pointer",
      }}
      title={
        request.payment_status === "Completed"
          ? "Payment already completed"
          : request.approval_status === "Approved" || request.approval_status === "Rejected"
          ? "Action already taken"
          : "Make Payment"
      }
    >
      {request.payment_status === "Completed" ? (
        <FaCheck /> // Icon indicating payment success
      ) : (
        <FaMoneyCheckAlt />
      )}{" "}
      {request.payment_status === "Completed" ? "Paid" : "Payment"}
    </button>

    {/* Approve Button */}
    <button
      onClick={() => handleApprove(request)}
      disabled={
        !verificationStatus[request.id] || // Disable if payment is not verified
        request.approval_status === "Approved" || // Disable if already approved
        request.approval_status === "Rejected" // Disable if already rejected
      }
      style={{
        backgroundColor:
          request.approval_status === "Approved" || request.approval_status === "Rejected"
            ? "#ccc"
            : "#28a745",
        color: "white",
        border: "none",
        borderRadius: "5px",
        padding: "5px 10px",
        cursor:
          !verificationStatus[request.id] ||
          request.approval_status === "Approved" ||
          request.approval_status === "Rejected"
            ? "not-allowed"
            : "pointer",
      }}
      title={
        !verificationStatus[request.id]
          ? "Verify payment first"
          : request.approval_status === "Approved"
          ? "Already approved"
          : request.approval_status === "Rejected"
          ? "Action already taken"
          : "Approve request"
      }
    >
      <FaCheck /> Approve
    </button>

    {/* Reject Button */}
    <button
      onClick={() => {
        setCurrentRequest(request);
        setIsRejectionModalOpen(true);
      }}
      disabled={
        request.approval_status === "Approved" || // Disable if already approved
        request.approval_status === "Rejected" // Disable if already rejected
      }
      style={{
        backgroundColor:
          request.approval_status === "Approved" || request.approval_status === "Rejected"
            ? "#ccc"
            : "#dc3545",
        color: "white",
        border: "none",
        borderRadius: "5px",
        padding: "5px 10px",
        cursor:
          request.approval_status === "Approved" || request.approval_status === "Rejected"
            ? "not-allowed"
            : "pointer",
      }}
      title={
        request.approval_status === "Approved"
          ? "Action already taken"
          : request.approval_status === "Rejected"
          ? "Already rejected"
          : "Reject request"
      }
    >
      <FaTimes /> Reject
    </button>
  </div>
</td>



                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  No assigned requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {requests.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}

      {/* Payment Modal */}
{/* Payment Modal */}
{isPaymentModalOpen && (
  <div className="employee-modal-overlay">
    <div className="employee-modal">
      <h3 className="employee-modal-title">Payment Verification</h3>
      
      {/* Payment Option Selection */}
      <div className="paymentOptions">
        <label className="employee-option">
          <input
            type="radio"
            value="NetBanking"
            checked={selectedPaymentOption === "NetBanking"}
            onChange={(e) => setSelectedPaymentOption(e.target.value)}
            className="employee-radioInput"
          />
          <span className="employee-radioText">Net Banking</span>
        </label>
        <label className="option">
          <input
            type="radio"
            value="UPI"
            checked={selectedPaymentOption === "UPI"}
            onChange={(e) => setSelectedPaymentOption(e.target.value)}
            className="employee-radioInput"
          />
          <span className="employee-radioText">UPI</span>
        </label>
      </div>

      {/* Conditional Fields */}
      {selectedPaymentOption === "NetBanking" && (
        <div className="employee-input-container">
          <input
            type="text"
            placeholder="Enter Account Number"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
            className="employee-input"
          />
        </div>
      )}

      {selectedPaymentOption === "UPI" && (
        <div className="employee-input-container">
          <input
            type="text"
            placeholder="Enter UPI ID"
            value={upiId}
            onChange={(e) => setUpiId(e.target.value)}
            className="employee-input"
          />
        </div>
      )}

      {/* Amount Input */}
      <input
        type="number"
        placeholder="Enter amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        className="employee-input"
      />

      {/* Buttons */}
      <div className="employee-buttonContainer">
        <button
          onClick={handleVerifyPayment}
          className="employee-modal-btn employee-primaryButton"
        >
          Verify
        </button>
        <button
          onClick={() => setIsPaymentModalOpen(false)}
          className="employee-modal-btn employee-secondaryButton"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}



      {/* Rejection Modal */}
      {isRejectionModalOpen && (
  <div className="employee-modal-overlay">
    <div className="employee-modal">
      <h3 className="employee-modal-title">Reason for Rejection</h3>
      <textarea
        placeholder="Enter rejection reason"
        value={rejectionReason}
        onChange={(e) => setRejectionReason(e.target.value)}
        className="employee-input"
      />
      <div className="employee-buttonContainer">
        <button onClick={() => handleReject(currentRequest)} className=" employee-modal-btn  employee-primaryButton">
          Reject
        </button>
        <button
          onClick={() => setIsRejectionModalOpen(false)}
          className="employee-modal-btn  employee-secondaryButton"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default AssignedRequests;
